export function onBlur() {
  this.keys.clear();
}
